"use client"

import { format, setMonth, setYear } from "date-fns"
import { vi } from "date-fns/locale"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select"

interface MonthYearPickerProps {
  label?: string
  date?: Date
  onChange?: (date: Date | undefined) => void
}

export function MonthYearPicker({ label, date, onChange }: MonthYearPickerProps) {
  const currentDate = date || new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()

  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i)
  const months = Array.from({ length: 12 }, (_, i) => ({
    value: i,
    label: format(new Date(2000, i), 'MMMM', { locale: vi })
  }))

  const handleMonthChange = (month: string) => {
    if (onChange) {
      const newDate = setMonth(currentDate, parseInt(month))
      onChange(newDate)
    }
  }

  const handleYearChange = (year: string) => {
    if (onChange) {
      const newDate = setYear(currentDate, parseInt(year))
      onChange(newDate)
    }
  }

  return (
    <div className="flex items-center space-x-2">
      <Select
        value={currentMonth.toString()}
        onValueChange={handleMonthChange}
      >
        <SelectTrigger className="w-[130px]">
          <SelectValue placeholder="Chọn tháng" />
        </SelectTrigger>
        <SelectContent>
          {months.map((month) => (
            <SelectItem key={month.value} value={month.value.toString()}>
              {month.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={currentYear.toString()}
        onValueChange={handleYearChange}
      >
        <SelectTrigger className="w-[100px]">
          <SelectValue placeholder="Chọn năm" />
        </SelectTrigger>
        <SelectContent>
          {years.map((year) => (
            <SelectItem key={year} value={year.toString()}>
              {year}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
} 